module.exports = __webpack_public_path__ + "static/img/brees-2012-top-image-thumb.da2e986.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-top-image-thumb.jpg
// module id = cbh1
// module chunks = 1